



























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SearchService from '@/services/SearchService'
import FormatDate from '@/helpers/FormatDate'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import { ETargetData, ETargetSeach, SearchResult } from '@/models'
import LoadingSearch from '@/components/Loading/LoadingSearch.vue'
import { hanldeUserStatus, removeHTML } from '@/helpers/Common'
import {getModule} from "vuex-module-decorators";
import store from "@/store";
import UserInfo from "@/store/modules/UserInfo";
const UserModule = getModule(UserInfo, store)

@Component({ components: { LoadingSearch } })
export default class SearchPage extends Vue {
  keyWords: string = ''
  private keyWordText: string = ''
  searchResults: SearchResult[] = []
  page: number = 1
  maxPage: number = 1
  total: number = 0
  loading: boolean = true
  private limit: number = this.$store.state.setting.setting.setting_display
    .number_item_lists
  eTargetSeach = ETargetSeach
  eTargetData = ETargetData
  noAvatar = require('@/assets/images/avatar-default.png')
  private ATTACH_FILE: string = 'ATTACH_FILE'
  private MESSAGE_DELETED: string = 'MESSAGE_DELETED'
  private LEAVE_GROUP_CHAT: string = 'LEAVE_GROUP_CHAT'
  private LEAVE_SYSTEM: string = 'LEAVE_SYSTEM'

  created() {
    this.getAllResult()
  }

  removeHTMLFunction(content: string): any {
    return removeHTML(content)
  }

  getUpdaterAvatar(result: any): string {
    return result &&
      result.updater &&
      result.updater.user_profile &&
      result.updater.user_profile.avatar
      ? result.updater.user_profile.avatar
      : ''
  }

  @Watch('$route.params.research')
  watchGetAll() {
    this.page = 1
    this.getAllResult()
    this.$bvModal.hide(this.$route.params.modalId)
    this.scrollToTopAfterResearch()
  }

  private scrollToTopAfterResearch() {
    // iOS Safari can keep previous visual viewport after closing modal + focusing input.
    // Force reset to top on every re-search to keep consistent UX.
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'auto' })
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      })
    })
  }

  /**
   * Call API to get results
   */
  getAllResult(loadMore?: boolean) {
    if (!loadMore) {
      this.searchResults = []
      this.total = -1
    }
    this.loading = true
    this.keyWords = this.$route.query.keyword_search as string
    this.keyWordText = (this.$route.query.keyword_search as string).trim()
    this.keyWordText = this.keyWordText
      .replaceAll('　', ',')
      .replaceAll(' ', ',')
      .replaceAll(/,{2,}/g, ',')
    let searchData: any = {
      target_search: this.$route.query.target_search as string,
      target_data: String(this.$route.query.target_data_string).split(','),
      keyword_search: this.keyWordText,
      time_start: this.$route.query.time_start as string,
      time_end: this.$route.query.time_end as string
    }

    if (
      searchData.target_search == ETargetSeach.SHARED_FOLDER ||
      searchData.target_search == ETargetSeach.TOPIC
    ) {
      searchData.target_group = this.$route.query.target_group as string
    }

    SearchService.getSeachAdvancedResult(searchData, this.page, this.limit)
      .then(res => {
        if (res.status === 200) {
          if (loadMore) {
            this.searchResults = [...this.searchResults, ...res.data.data]
          } else {
            this.searchResults = res.data.data
          }

          this.maxPage = res.data.last_page
          this.total = res.data.total
        }
      })
      .catch(err => console.log(err))
      .finally(() => (this.loading = false))
  }

  /**
   * Call API for loadmore
   */
  handleLoadmore() {
    ++this.page
    this.getAllResult(true)
  }

  /**
   * Handle keywords
   *
   * Mark red for keywords
   */
  markRedKeyWord(result: SearchResult, target: ETargetData) {
    let targetData = target

    //handle content need to mark read
    let content = ''
    switch (targetData) {
      case ETargetData.TITLE:
        if (result.belong_to === ETargetSeach.CHAT) {
          return this.handleChatTitle(result)
        }
        content = result.title
        break
      case ETargetData.CONTENT:
        if (
          result.belong_to === ETargetSeach.CHAT
          // &&
          // result.content === 'chat_detail_message_deleted'
        ) {
          const text = result.content ? result.content.split(',')[0] : ''
          const name = result.content ? result.content.split(',')[1] : ''
          switch (text) {
            case this.ATTACH_FILE:
              return `<span class='text-secondary-tint-less'>${this.$t(
                'common.message.chat_no_content'
              )}</span>`
            case this.MESSAGE_DELETED:
              return `<span class='text-secondary-tint-less'>${this.$t(
                'chat.list.msg.msg_deleted'
              )}</span>`
            case this.LEAVE_GROUP_CHAT:
              return `<span class='text-secondary-tint-less'>${this.$t(
                'chat.list.msg.leave_group_chat',
                {
                  name: name
                }
              )}</span>`
            case this.LEAVE_SYSTEM:
              return `<span class='text-secondary-tint-less'>${this.$t(
                'chat.list.msg.leave_system',
                {
                  name: name
                }
              )}</span>`
            case 'chat_detail_message_deleted':
              return `<span class='text-secondary-tint-less'>${this.$t(
                'chat.list.msg.msg_deleted'
              )}</span>`
          }
        }
        content = result.content
        break
      case ETargetData.UPLOADER:
        if (!result.updater) return ''
        content = result.updater.name
        break
      default:
        break
    }

    //check shared folder comment
    if (
      result.belong_to === ETargetSeach.SHARED_FOLDER &&
      targetData === ETargetData.COMMENT
    ) {
      content = result.content
    }

    //check topic comment
    if (
      result.belong_to === ETargetSeach.TOPIC &&
      !result.is_topic &&
      targetData === ETargetData.COMMENT
    ) {
      content = result.content
    }

    //validate content
    if (!content) {
      return this.handleNonContent(result)
    }

    //convert content to raw text
    const text = this.removeHTMLFunction(content)

    //mark read for target data only
    if (
      !String(this.$route.query.target_data_string)
        .split(',')
        .includes(String(targetData))
    )
      return text

    //find index of keyword
    const keyWords = this.keyWordText.split(',')
    let replaceText = text
    keyWords.forEach(kw => {
      replaceText = this.findKeyword(replaceText, kw)
    })

    return replaceText
      .replaceAll('φ', '<span class="text-danger">')
      .replaceAll('▽', '</span>')
  }

  // Hiragana -> Katakana conversion
  toHira(str: string) {
    return str.replaceAll(/[\u30A1-\u30FA]/g, c =>
      String.fromCodePoint(c?.codePointAt(0) ?? 0 - 0x60)
    );
  }

  // Katakana -> Hiragana conversion
  toKata(str: string) {
    return str.replaceAll(/[\u3041-\u3096]/g, c =>
      String.fromCodePoint(c?.codePointAt(0) ?? 0 + 0x60)
    );
  }

  /**
   * findKeyword
   */
  findKeyword(text: string, kw: string) {
    if (!kw || !text) return text;

    // STEP 1: Create a smart regex pattern for both English & Japanese
    // It splits the keyword and creates a variant group for each character
    const pattern = kw.split('').map(char => {
      const h = this.toHira(char);
      const k = this.toKata(char);
      
      if (h === k) {
        // For English/Special chars: Escape characters to prevent Regex errors
        return char.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
      } else {
        // For Japanese: creates a group like [てテ] to match both Hiragana & Katakana
        return `[${h}${k}]`;
      }
    }).join('');

    // 'i' flag: Case-insensitive (Handles English: Apple === apple)
    // 'g' flag: Global search (Finds all occurrences)
    const regex = new RegExp(`(${pattern})`, 'ig');

    // STEP 2: Locate the first occurrence for slicing logic
    const keyWordIndex = text.search(regex);
    if (keyWordIndex === -1) return text;

    // STEP 3: Handle display text slicing (keeping your original logic)
    const startSlice = Math.max(0, keyWordIndex - 5);
    const endSlice = keyWordIndex + 200;
    
    const contentSliced = text.slice(startSlice, endSlice);
    const prefix = startSlice === 0 ? '' : '...';
    const suffix = endSlice >= text.length ? '' : '...';

    const contentDisplay = prefix + contentSliced + suffix;

    // STEP 4: Highlight the keyword
    // $1 refers to the original text found (preserves original case/script)
    return contentDisplay.replace(regex, 'φ$1▽');
  }


  /**
   * Hanle content null
   */
  handleNonContent(result: SearchResult) {
    const nonContent = (string: string) => {
      return `<span class="text-secondary-tint-less">${string}</span>`
    }
    switch (result.belong_to) {
      case ETargetSeach.TOPIC:
        return nonContent(this.$t('common.message.topic_no_content') as string)
      case ETargetSeach.CALENDAR:
        return ''
      case ETargetSeach.CHAT:
        return nonContent(this.$t('chat.list.msg.message_deleted') as string)
      case ETargetSeach.SHARED_FOLDER:
        return nonContent(this.$t('common.message.file_no_content') as string)
      default:
        return ''
    }
  }

  /**
   * Handle chat title
   */
  handleChatTitle(chat: SearchResult) {
    if (!chat.is_direct_chat) {
      return chat.name
    }

    const groupChatName = chat.user_leave_chat
      ? [
          {
            name: hanldeUserStatus(
              chat.user_leave_chat?.name,
              chat.user_leave_chat?.leaveType
            )
          }
        ]
      : chat.user_group_chat || []

    if (!groupChatName || groupChatName.length === 0) {
      return ''
    }

    const suffix = this.$t('common.suffix.san')
    const comma = this.$t('chat.comma')

    const displayUsers = groupChatName.slice(0, 2)
    const mappedNames = displayUsers
      .map((item: any) => item.name)
      .join(`${suffix}${comma}`)

    const groupName = `${mappedNames}${suffix}`

    const otherUserCount = Math.max(0, groupChatName.length - 2)
    const extraText =
      otherUserCount > 0
        ? this.$t('chat.chat_group_name_with', {
            other_user_count: otherUserCount
          })
        : ''

    return `${groupName}${extraText}${this.$t('chat.chat_with')}`
  }

  /**
   * Helper format date
   */
  formatDateWithDays(date: string) {
    return FormatDate.formatDateWithDays(date)
  }

  /**
   * For file
   *
   * Get file format
   */
  getFileFormat(path: string) {
    const pathSplit = path.split('.')
    const fileExtension = pathSplit[pathSplit.length - 1]
    return CheckFileFormat.getFileFormat(fileExtension)
  }

  /**
   * For file
   *
   * Get icon name
   */
  getIconName(path: string) {
    const pathSplit = path.split('.')
    const fileExtension = pathSplit[pathSplit.length - 1]
    return CheckFileFormat.getIconClassName(
      CheckFileFormat.getFileFormat(fileExtension)
    )
  }

  /**
   * Research - open modal search
   */
  backToSearch() {
    this.$bvModal.show('modal-search-header')
  }

  /**
   * Jupm to detail page
   */
  jumpToDetail(currentSelected: SearchResult) {
    switch (currentSelected.belong_to) {
      case ETargetSeach.TOPIC:
        if (this.$route.query.target_group) {
          return ({
            name: 'group-new-feed-topic-detail',
            params: {
              groupId: String(this.$route.query.target_group),
              topicId: String(currentSelected.topic_id)
            },
            query: currentSelected.is_topic
              ? {}
              : { commentSearchId: String(currentSelected.cmt_id) }
          })
        } else {
          return ({
            name: 'common-topic-new-feed-topic-detail',
            params: { topicId: String(currentSelected.topic_id) },
            query: currentSelected.is_topic
              ? {}
              : { commentSearchId: String(currentSelected.cmt_id) }
          })
        }
      case ETargetSeach.CALENDAR:
        return ({
          name: 'calendar-preview',
          params: { id: String(currentSelected.id) }
        })
      case ETargetSeach.CHAT:
        return ({
          name: 'chat-detail',
          params: { groupChatId: String(currentSelected.group_chat_id) },
          query: { message: String(currentSelected.id) }
        })
      case ETargetSeach.SHARED_FOLDER:
        if (this.$route.query.target_group) {
          return ({
            name: 'group-shared-folder-file-detail',
            params: {
              groupId: String(this.$route.query.target_group),
              fileId: String(currentSelected.id)
            }
          })
        } else {
          return ({
            name: 'common-topic-shared-folder-file-detail',
            params: { fileId: String(currentSelected.id) }
          })
        }
      default:
        return {}
    }
  }
}
